import React from "react";
import DropdownMenu from "./DropdownMenu";

const languages = [
  'C#',
  'Visual Basic',
  'Visual C++',
];
interface LangMenuProps {
  changeLanguage: (language: string) => void;
  selectedLanguage: string;
}

export const LangMenu: React.FC<LangMenuProps> = ({ changeLanguage, selectedLanguage }) => {
  return (
    <DropdownMenu
      label=""
      items={languages}
      selectedItem={selectedLanguage}
      onSelect={changeLanguage}
    />
  );
};